
window.ScraperApp = angular.module 'ScraperApp', [ 'ui.router' ]
